import { Directive, HostListener, Inject, Input } from '@angular/core';
import { DestroyedService } from 'app/shared/destroyed/destroyed.service';
import { CxUiComponentService } from '../cx-component.service';
import { DOCUMENT } from '@angular/common';

@Directive({
  /* tslint:disable */
  selector: 'cwc-button[type="submit"][form]',
  providers: [DestroyedService, CxUiComponentService],
})
export class CxButtonProviderDirective {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  @Input()
  public form?: string;

  @HostListener('cwcClick')
  public cwcClick() {
    const form$ = this.document.querySelector(`form#${this.form}`) as HTMLFormElement;

    if (form$) {
      form$.addEventListener('submit', (e: Event) => e.preventDefault());
      form$.submit();
    }
  }
}
